module.exports = __webpack_public_path__ + "static/media/cases_3d_03b.977d4c0f.jpg";